<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Monitor Fiscal</h4>
          </div>

          <div class="row">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_fim">
            <select class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="tipo">
              <option value="0">Desktop</option>
              <option value="1">App</option>
            </select>
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile" v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>

          <table class="table table-striped" v-if="tipo == 0">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>cStat</th> 
                <th>Notas</th>
                <th class="text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="instalacao of instalacoes">
                <td>{{ instalacao.apelido }} ({{ instalacao.idi }})</td>
                <td :title="instalacao.motivo">
                  <span class="badge" :style="{ background: `${getBackground(instalacao.cStat)}`, 'border-color': `${getBackground(instalacao.cStat)}` }" style="width: 40px">{{ instalacao.cStat }}</span>
                </td>
                <td>{{ instalacao.notas }}</td>
                <td class="text-right">{{ instalacao.valor | currencyBrl(true) }}</td>
              </tr>
              <tr v-if="!instalacoes || !instalacoes.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-striped" v-if="tipo == 1">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>cStat</th> 
                <th>Notas</th>
                <th class="text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="instalacao of instalacoes">
                <td>{{ instalacao.apelido }} ({{ instalacao.idi }})</td>
                <td :title="instalacao.motivo">
                  <span class="badge" :style="{ background: `${getBackground(instalacao.cStat)}`, 'border-color': `${getBackground(instalacao.cStat)}` }" style="width: 40px">{{ instalacao.cStat }}</span>
                </td>
                <td>{{ instalacao.notas }}</td>
                <td class="text-right">{{ instalacao.valor | currencyBrl(true) }}</td>
              </tr>
              <tr v-if="!instalacoes || !instalacoes.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import InstalacaoService from '@/services/InstalacaoService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {

        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),

        instalacoes: [],
        total: 0,
        tipo:0,
        from: 0,
        to: 0,
        current_page: 1,
        pageCount: 0,
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadInstalacoes()
      },

      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        if(this.tipo == 0){
          this.loadInstalacoes()
        }else{
          this.loadInstalacoesApp()
        }
      },
      loadInstalacoes() {
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}`

        InstalacaoService.monitorFiscal(params).then(res => {
          this.instalacoes = res.data
        }).catch(err => {
          console.error(err)
        })
      },
      loadInstalacoesApp() {
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}`

        InstalacaoService.monitorFiscalApp(params).then(res => {
          this.instalacoes = res.data
        }).catch(err => {
          console.error(err)
        })
      },
      getBackground(cStat) {
        if(cStat == 100 || cStat == 150) return '#2ecc71';
        if(cStat == 102 || cStat == 135) return 'orange';

        return "red"
      }
    },
    mounted() {
      this.loadInstalacoes()
    }
}
</script>

<style>
  .status {
    display: inline-block; margin-right: 6px;
  }
  .status.danger {
    background-color: red;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.alive {
    background-color: #26de81;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.warning {
    background-color: #fed330;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
</style>